import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { PriceProvider } from './context';
import { PointsProvider } from "./sportsc/pointContext";
import { ArtclesProvider } from "./sportsc/articlesContext";

ReactDOM.render(
  <React.StrictMode>
    <ArtclesProvider>
    <PriceProvider>
    <PointsProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      </PointsProvider>
    </PriceProvider>
    </ArtclesProvider>
  </React.StrictMode>,
  document.getElementById("root")
);